import { render } from "./thresholdFilter.vue?vue&type=template&id=6d68df4e&scoped=true&ts=true"
import script from "./thresholdFilter.vue?vue&type=script&lang=ts"
export * from "./thresholdFilter.vue?vue&type=script&lang=ts"

import "./thresholdFilter.vue?vue&type=style&index=0&id=6d68df4e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d68df4e"]])

export default __exports__